// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#2979ff","accentColor":"#233c56","menuBgColor":"#233c56"};